// plan-17 S01: BIOS POST overlay — one-shot first cold load, 1.6s budget

import { load, save } from '../../core/save'

const POST_BUDGET_MS = 1600
const FADE_MS = 240

const POST_LINES = [
  'pa.oracle bios v 4.8 — copyright (c) probably.',
  '── post sequence ──',
  'cpu: 048 mhz ............ ok',
  'ram: 04848 kb ........... ok',
  'drone: 48.0 hz .......... synchronized',
  'standing wave: 48 cy .... locked',
  'golden pixel: 48,48 ..... present',
  'router: null ............ probably',
  'quorum: 48 / 48 ......... ok',
  '── post complete ──',
  'consensus: probably.',
]

export function shouldRunPost(): boolean {
  return !load().polishSeenPost
}

export async function runPost(_history: HTMLElement): Promise<void> {
  const reduced = document.body.classList.contains('vt-reduced-motion')

  const overlay = document.createElement('div')
  overlay.style.cssText = `
    position: fixed; inset: 0; z-index: 95;
    background: var(--vt-screen-bg);
    display: flex; flex-direction: column;
    padding: 48px 32px;
    font-family: var(--vt-font-mono);
    font-size: var(--vt-fs-body);
    color: var(--vt-green-dim);
    line-height: var(--vt-line-height);
    overflow: hidden;
  `
  document.body.appendChild(overlay)

  if (reduced) {
    // instant batch render at 0.4s equivalent
    for (const line of POST_LINES) {
      const el = document.createElement('div')
      el.textContent = line
      overlay.appendChild(el)
    }
    await sleep(200)
  } else {
    // stream lines at POST_CPS within the 1.6s budget
    const totalChars = POST_LINES.reduce((s, l) => s + l.length, 0)
    const charInterval = POST_BUDGET_MS / totalChars

    for (const line of POST_LINES) {
      const el = document.createElement('div')
      overlay.appendChild(el)
      for (let i = 0; i < line.length; i++) {
        el.textContent += line[i]
        await sleep(charInterval)
      }
    }
  }

  // fade to black
  overlay.style.transition = `opacity ${FADE_MS}ms ease-out`
  overlay.style.opacity = '0'
  await sleep(FADE_MS)
  overlay.remove()

  // mark seen
  const s = load()
  s.polishSeenPost = true
  save(s)
}

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
